//import 'dotenv/config'

const gqlApiUrl = process.env.REACT_APP_GQL_API_URL || 'http://localhost:4000/graphql'
const gqlClientTimeout = parseInt(process.env.REACT_APP_GQL_CLIENT_TIMEOUT) || 240000

export const GQL_API_URL = gqlApiUrl
export const GQL_CLIENT_TIMEOUT = gqlClientTimeout

export const UNIFY_ENABLED = process.env.REACT_APP_UNIFY_ENABLED === '1'
export const UNIFY_PROMO = UNIFY_ENABLED && process.env.REACT_APP_UNIFY_PROMO === '1'

export const APP_GQL_WS_URL = process.env.REACT_APP_GQL_WS_URL || 'wss://prd.api.sematics.io/graphql-ws' ;
